class TreatmentSaveController {

    constructor($rootScope, $stateParams, access, integrationService, currentPropertyService) {
        this.$rootScope = $rootScope;
        this.$stateParams = $stateParams;
        this.access = access;
        this.integrationService = integrationService;
        this.currentProperty = currentPropertyService;
    }

    $onInit () {
        this.activeTab = this.$stateParams.tab || 'treatment';
    }

    canShow () {
        let integration = this.currentProperty.get('integration');
        return !!this.treatment.id && (this.access.check('manager') || (integration && integration.allow_time_constraining));
    }
}

TreatmentSaveController.$inject = ['$rootScope', '$stateParams', 'access', 'integrationService', 'currentPropertyService'];

export default TreatmentSaveController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/treatment/controllers/treatment.save.controller.js